// 认证
import commonUtils from '@/utils/commonUtils.js'
import Cookies from 'js-cookie'
const sys_name = window.location.hostname + window.location.pathname

export function getCookie(key){
	if(commonUtils.isNull(Cookies.get(sys_name))){
		return;
	}
	let cookiesJson =JSON.parse(Cookies.get(sys_name))
	if(key==null){
		return cookiesJson
	}else{
		return cookiesJson[key]
	}
}

export function setCookie(key,value, config){
	let info = !commonUtils.isNull(Cookies.get(sys_name))?JSON.parse(Cookies.get(sys_name)):{}
	info[key]=value
	Cookies.set(sys_name,info, config)
}

export function removeCookie(){
	return Cookies.remove(sys_name)
}

export function getCookieByName(name) {
	return Cookies.get(name)
}

export function setCookieByName(name, value, config) {
	Cookies.set(name, value, config)
}

export function removeCookieByName(name){
	return Cookies.remove(name)
}